import React from 'react';
import cx from 'classnames';
import {Navigation} from '../../Navigation/Navigation';
import {Cell} from '../Cell/Cell';
import {LayoutComponentProps} from '../../../types/app-types';
import s from './SimpleLayout.scss';
import {BottomPlaceholder} from '../../Placeholders/BottomPlaceholder';
import {ReviewsSlot} from '../../ReviewsSlot/ReviewsSlot';
import {ProductPageTopSlot} from '../../ProductPageTopSlot/ProductPageTopSlot';
import {SimpleLayoutHeader} from './SimpleLayoutHeader';
import {SimpleLayoutLeftSection} from './SimpleLayoutLeftSection';
import {SimpleLayoutRightSection} from './SimpleLayoutRightSection';
import {ProductPageSlotIds} from '../../../constants';

export const SimpleLayout: React.FunctionComponent<LayoutComponentProps> = ({settings, globals}) => {
  const isPluginInstalledInTopSlot = !!globals.slots?.[ProductPageSlotIds.ProductPageTop];

  return (
    <article className={s.container}>
      <Cell className={s.width}>
        <div className={cx({[s.topSlot]: isPluginInstalledInTopSlot})}>
          <ProductPageTopSlot />
        </div>
        {settings.shouldShowNavigation && (
          <Navigation
            className={cx({
              [s.navigation]: !isPluginInstalledInTopSlot,
              [s.navigationSmallSpacingTop]: isPluginInstalledInTopSlot,
            })}
          />
        )}
      </Cell>
      <SimpleLayoutHeader settings={settings} globals={globals} />
      <div className={cx(s.width, s.main)}>
        <SimpleLayoutLeftSection globals={globals} settings={settings} />
        <SimpleLayoutRightSection globals={globals} settings={settings} />
      </div>
      <Cell>
        <ReviewsSlot />
        <BottomPlaceholder />
      </Cell>
    </article>
  );
};
